import { create } from 'zustand';

/**
 * Store global para estado da chamada ativa.
 * Permite que BaseLayout saiba se deve bloquear navegação.
 */
interface ChamadaStore {
  /** True quando uma chamada está em modo operação/resumo */
  chamadaEmAndamento: boolean;
  setChamadaEmAndamento: (v: boolean) => void;
}

export const useChamadaStore = create<ChamadaStore>((set) => ({
  chamadaEmAndamento: false,
  setChamadaEmAndamento: (v) => set({ chamadaEmAndamento: v }),
}));
